var defineProperty = require('core-js/internals/object-define-property.js').f;
var isValidSubmitter = require('../internals/is-valid-submitter.js');
var NAME = 'submitter';

// Safari 15 implement SubmitEvent interface but event.submitter is always null for regular submit (but provided for form.requestSubmit(submitter))
// We need to test if submitEvent.submitter is provided
// See also https://trac.webkit.org/changeset/279979/webkit
var supported =
  typeof window.SubmitEvent === 'function' &&
  (function (parent) {
    var supported = false;
    var document = parent.ownerDocument;

    var form = document.createElement('form');
    parent.appendChild(form);

    var submitter = document.createElement('button');
    form.appendChild(submitter);

    form.addEventListener('submit', function (e) {
      e.preventDefault(); // don't submit the form
      supported = e.submitter === submitter;
    });
    submitter.click();
    // NOTE:use stopImmediatePropagation on submit and click to reduce footprint of our test

    // Cleanup
    parent.removeChild(form);

    return supported;
  })(document.body);

// Require support of element.closest()
// https://stackoverflow.com/questions/2066162/how-can-i-get-the-button-that-caused-the-submit-from-the-form-submit-event/61110260#61110260
// https://github.com/hyperform/hyperform/blob/master/src/tools/catch_submit.js
// https://stackoverflow.com/questions/2066162/how-can-i-get-the-button-that-caused-the-submit-from-the-form-submit-event#comment40666306_17805011
// https://developer.mozilla.org/en-US/docs/Web/API/SubmitEvent#browser_compatibility
if (!supported) {
  var submitterCandidate = null;

  /** @param form */
  function getSubmitter(form) {
    //Do not use document.activeElement, because Safari reset focus to body, and buttonElement.click() doesn't change focus. See https://stackoverflow.com/users/470117/mems
    if (isValidSubmitter(submitterCandidate, form)) return submitterCandidate;

    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return; // FIXME this condition is "too early", no event listener have the opportunity to prevent default of this event

      submitterCandidate = event.target.closest('button, input');
    },
    true
  );

  // Note for implicit submission (ex: "hitting the "enter" key while a text control is focused implicitly submits the form"), a click is triggered on the default button
  // See https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#implicit-submission
  // NOTE:support implicit submission for forms that don't have any default button and 0 or one field that blocks implicit submission. In that case the submitter is null (or the form itself?), latestSubmitter should be null
  // No need to listen keypress event:
  /*
  var textTypes = ['text', 'search', 'tel', 'password'];
  function isActivationSubmitFormWithKey(element, key) {
    key = key === 'Spacebar' ? ' ' : key; // fix "Spacebar" is for old browsers, see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#whitespace_keys
    return (
      (isActivationSubmitForm(element) && (key === 'Enter' || key === ' ')) ||
      (element.tagName === 'INPUT' && textTypes.indexOf(element.type) >= 0 && key === 'Enter')
    );
  }

  document.addEventListener(
    'keypress',
    function (event) {
      if (event.defaultPrevented) return; // FIXME this condition is "too early", no event listener have the opportunity to prevent default of this event
      if (!isActivationSubmitFormWithKey(event.target)) return;

      submitterCandidate = event.target;
    },
    true
  );
  */

  document.addEventListener(
    'submit',
    function (event) {
      var submitter = getSubmitter(event.target); // compute now, before the DOM can be altered
      submitterCandidate = null;
      defineProperty(event, NAME, {
        configurable: true,
        get: function () {
          return submitter;
        },
      });
    },
    true
  );
}
